import React from 'react';
import {IDateFormatdProps} from './DateFormat.types';

export const DateFormat: React.FC<IDateFormatdProps>=({date,lang,type,format}:IDateFormatdProps)=> {
    const zeros=(v:any,length:number)=>"000000000000".substring(0,length-(""+v).length)+v;
    const d=new Date(date);
    const day=d.getDate().toString();
    let month=d.toLocaleString(lang, { month: type=="short"?'short':'long' });
    //f (type=="short") month=month.toUpperCase();
    const year=d.getFullYear().toString();
    if (type=="full") {
        return <>{zeros(day,2)+"/"+zeros(d.getMonth()+1,2)+"/"+zeros(year,4)}</>;
    }
    return typeof format=="function"?format(day,month,year):<>{`${day} ${month}`}</>;
}

